// extracted by mini-css-extract-plugin
export default {"botao":"botao_botao__QwwfC","primary":"botao_primary__DJ6E9","secondary":"botao_secondary__J0cJr"};